import { genid } from "@workspace/shared/utils";

/**
 * A new order's id (HA-963). It was `ORD-${Date.now()}`, so two terminals starting an order in the same millisecond got the
 * same id, and HA-784 then merged the second order into the first. The server takes the id as given, with no format rule.
 *
 * `crypto.randomUUID` exists only in a secure context. Where it is missing (a plain-HTTP origin), the app's own `genid`
 * stands in: 16 secure-random alphanumeric characters, which is just as collision-safe.
 */
export function newOrderId(): string {
	return `ORD-${randomId()}`;
}

function randomId(): string {
	return typeof crypto !== "undefined" &&
		typeof crypto.randomUUID === "function"
		? crypto.randomUUID()
		: genid();
}
